import {Base} from "./base";

class ConsultService extends Base {
  constructor() {
    super();
  }

  /**
   * 发布图文咨询V2
   * @param consulterName
   * @param docId
   * @param consulterIdcard
   * @param consulterMobile
   * @param consultContent
   * @param illnessName
   * @param illnessTime
   * @param expectedHelpContent
   * @param attaIdList
   * @param staffDeptId
   * @param dictionaryId
   * @param missionDeptId
   * @param consultSourceId
   * @param consultSource
   * @param compatId
   * @param surgeryState
   * @returns {Promise<void>}
   */
  async issueV2({
                  consulterName,
                  docId,
                  consulterIdcard,
                  consulterMobile,
                  consultContent,
                  illnessName,
                  illnessTime,
                  expectedHelpContent,
                  attaIdList,
                  staffDeptId,
                  dictionaryId,
                  missionDeptId,
                  consultSource,
                  consultSourceId,
                  compatId,
                  surgeryState
                }) {
    const {code, obj = null} = await this.$http('nethos.consult.info.docpic.issue.v2', {
      consulterName,
      docId,
      consulterIdcard,
      consulterMobile,
      consultContent,
      illnessName,
      illnessTime,
      expectedHelpContent,
      attaIdList,
      staffDeptId,
      dictionaryId: dictionaryId ? dictionaryId : undefined,
      missionDeptId: missionDeptId ? missionDeptId : undefined,
      surgeryState: surgeryState ? surgeryState : undefined,
      consultSource,
      consultSourceId,
      compatId
    });
    return code === '0' ? obj : null;
  }

  /**
   * 发布私人医生
   * @param consulterName
   * @param docId
   * @param consulterIdcard
   * @param consulterMobile
   * @param consultContent
   * @param illnessName
   * @param illnessTime
   * @param expectedHelpContent
   * @param attaIdList
   * @param staffDeptId
   * @param personalServeId
   * @returns {Promise<void>}
   */
  async infoPersonalIssue({
                            consulterName,
                            docId,
                            consulterIdcard,
                            consulterMobile,
                            consultContent,
                            illnessName,
                            illnessTime,
                            expectedHelpContent,
                            attaIdList,
                            staffDeptId, personalServeId
                          }) {
    const {code, obj = null} = await this.$http('nethos.consult.info.personal.issue', {
      consulterName,
      docId,
      consulterIdcard,
      consulterMobile,
      consultContent,
      illnessName,
      illnessTime,
      expectedHelpContent,
      attaIdList,
      staffDeptId, personalServeId
    });
    return code === '0' ? obj : null;
  }

  /**
   * 咨询详情
   * @param consultId
   * @returns {Promise<{}>}
   */
  async detail(consultId) {
    const {code, obj = {}} = await this.$http('nethos.consult.info.detail', {consultId});
    return code === '0' ? obj : {};
  }

  /**
   * 复诊续方编号
   * @param compatId
   * @returns {Promise<string>}
   */
  async infoConsultationConsultId(compatId) {
    const {obj} = await this.$http('nethos.consult.info.consultation.consult.id', {compatId})
    return obj || "";
  }

  /**
   * 获取预问诊Id
   * @param params.compatId
   * @param params.docId
   * @returns {Promise<string>}
   */
  async getPreConsultId(params) {
    const {obj = ''} = await this.$http('nethos.consult.info.consultation.consult.sync', params);
    return obj;
  }

  /**
   * 医生有进行中的单子
   * @description 05051000 进行中
   * @description 05040030 未支付
   * @param docId
   * @param compatId
   * @returns {Promise<string>}
   */
  async infoConsultationNeedPay(compatId, docId) {
    const {code} = await this.$http('nethos.consult.info.consultation.need.pay', {
      compatId, docId
    }, {}, {
      showError: false
    });
    return code;
  }

  /**
   * 正在进行中的单子
   * @param docId
   * @param compatId
   * @returns {Promise<{}>}
   */
  async infoConsultationGoingPatInfo(docId, compatId) {
    const {obj = {}} = await this.$http('nethos.consult.info.consultation.going.pat.info', {
      docId, compatId
    });
    return obj;
  }

  /**
   * 最近订单
   * @param compatId
   * @param docId
   * @returns {Promise<[]>}
   */
  async orderList({compatId, docId}) {
    const {list = []} = await this.$http('nethos.consult.order.list', {
      compatId, docId
    });
    return list
  }

  /**
   * 护理列表/搜索
   * @param deptName
   * @returns {Promise<[]>}
   */
  async staffList(deptName) {
    const {list = []} = await this.$http('nethos.hos.staff.list', {
      deptName
    });
    return list;
  }

  /**
   * 诊疗记录详情
   * @param consultId
   * @returns {Promise<{}>}
   */
  async medicalRecordInfo(consultId) {
    const {obj = {}} = await this.$http('nethos.consult.medical.record.info', {
      consultId
    }, {}, {showError: false});
    return obj;
  }

  /**
   *
   * @param personalServeId
   * @returns {Promise<String>}
   */
  async infoCheckPersonalServe(personalServeId) {
    const {obj = ''} = await this.$http('nethos.consult.info.check.personal.serve', {
      personalServeId
    });
    return obj;
  }


  /**
   * 回复图片消息
   * @param consultId
   * @param attaId
   * @returns {Promise<string>}
   */
  async replyPic(consultId, attaId) {
    const {code = '0'} = await this.$http('nethos.consult.info.reply', {
      attaIdList: [attaId],
      consultId: consultId
    })
    return code;
  }

  /**
   * 回复附件消息
   * @param consultId
   * @param replyContent
   * @returns {Promise<string>}
   */
  async replyDocument(consultId, replyContent) {
    const {code = '0'} = await this.$http('nethos.consult.info.reply', {
      attaIdList: [replyContent],
      msgType: 'DOCUMENT',
      consultId: consultId
    })
    return code;
  }

  /**
   * 通用义诊活动首页
   * @param options
   * @param options.freeClinicId
   * @param options.deptId
   * @param options.docType
   * @returns {Promise<{}>}
   */
  async freeIndex(options) {
    const {code = '', obj = {}} = await this.$http('nethos.consult.free.index', {
      ...options
    })
    return obj;
  }

  /**
   *
   * @param freeClinicId
   * @returns {Promise<*[]>}
   */
  async freeDept(freeClinicId) {
    const {obj = []} = await this.$http('nethos.consult.free.dept', {
      freeClinicId
    });
    return obj
  }

  /**
   * 义诊 医生列表
   * @param freeClinicId
   * @param deptIds
   * @returns {Promise<[]>}
   */
  async freeDocs(freeClinicId, deptIds) {
    const {obj = []} = await this.$http('nethos.consult.free.fever.doc.list', {
      freeClinicId, deptIds
    });
    return obj;
  }

  /**
   * 义诊 团队列表
   * @param freeClinicId
   * @param teamIds
   * @returns {Promise<[]>}
   */
  async freeTeams(freeClinicId, teamIds) {
    const {obj = []} = await this.$http('nethos.consult.free.team.list', {
      freeClinicId, teamIds
    });
    return obj;
  }

  /**
   * 咨询附件数量
   * @param consultId
   * @returns {Promise<number>}
   */
  async attaTotal(consultId) {
    const {obj = 0} = await this.$http('nethos.consult.atta.num', {consultId})
    return obj || 0
  }

  /**
   * 补充资料
   * @param options
   * @param options.consultId
   * @param options.attaIdList
   * @param options.supplementContent
   * @returns {Promise<{code}>}
   */
  async infoSupplement(options) {
    return await this.$http('nethos.consult.info.supplement', options)
  }
}

export const consultService = new ConsultService();



// WEBPACK FOOTER //
// ./src/services/consult.js